module.exports = __webpack_public_path__ + "img/02logo-rin2022.669e8ace.png";